import type { ReactNode } from 'react'

import logoHorizontal from '../assets/aeris-logo-horizontal.png'
import mark from '../assets/aeris-mark.png'
import { useBranding } from '../lib/use-branding.ts'

/**
 * A logo que aparece no sistema — da loja, ou a da Aeris (F169).
 *
 * ## A armadilha que este componente existe para não repetir
 *
 * Os quatro `<img>` que havia antes aplicavam `brightness-0 invert`: o PNG da
 * Aeris é escuro e é PINTADO DE BRANCO por CSS para viver sobre o navy. Aplicar
 * o mesmo filtro à logo de um cliente transformaria a marca dele numa silhueta
 * branca — e quem subisse uma logo já clara veria um retângulo vazio.
 *
 * Então o filtro é do ASSET, não do lugar: a logo da loja sai como ela é, e a
 * prévia da tela de Aparência mostra exatamente isso sobre o fundo do menu,
 * que é onde ela vai viver.
 *
 * ## Por que não está em `@aeris/ui`
 *
 * O kit não tem camada de dados, de propósito. Este componente PERGUNTA qual é
 * a marca da conta; um componente do kit teria de receber a URL pronta, e
 * então cada um dos lugares que desenha a logo precisaria lembrar de buscá-la
 * — que é exatamente o espalhamento que se está removendo.
 */
export const BrandLogo = ({
  variant,
  className,
}: {
  /** `mark` é o quadrado da barra recolhida; `horizontal` é o resto. */
  variant: 'horizontal' | 'mark'
  className?: string
}): ReactNode => {
  const { logoUrl } = useBranding()

  if (logoUrl !== null) {
    return (
      <img
        src={logoUrl}
        alt="Logo da loja"
        /*
         * `object-contain`: a logo de um cliente tem a proporção que ele
         * escolheu, e esticá-la para caber numa caixa é a forma mais rápida de
         * ofender alguém com a própria marca.
         */
        className={`${className ?? ''} object-contain`.trim()}
      />
    )
  }

  return (
    <img
      src={variant === 'mark' ? mark : logoHorizontal}
      alt="Aeris One — Sistema de Gestão"
      /*
       * O asset oficial, usado como fornecido (docs/brand/BRAND.md), pintado
       * de branco para o navy. O filtro vale SÓ aqui.
       */
      className={`${className ?? ''} ${variant === 'mark' ? '' : 'brightness-0 invert'}`.trim()}
    />
  )
}
